/** Tüm mevcut sütunları döner; migration öncesi/sonrası uyumlu */
export const FORUM_PUBLIC_SELECT = '*';
